import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {STATIC_IMAGE, TICK_DOMAIN} from '../../../config/config';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const Canceled = ({orderData}: {orderData: OrderData}) => {
    const {t}=useTranslation('suspendedConfirmation');
    return (
        <Card
            mainTitle={t('eventCanceled', {nameFirst: orderData.nameFirst})} 
            subTitle={orderData.eventTitle} 
            {...orderData}
        >
            <css.confirmationBoxFlexEnd>
                <css.rightBox>
                    <css.titleStart>
                        {t('importantUpdate')}
                    </css.titleStart>
                    <css.boldText>
                        {t('cantConfirm')}
                    </css.boldText>
                    <css.boldText>
                        {t('apology')}
                    </css.boldText>
                </css.rightBox>
                <css.image
                    height='130px'
                    src={`${STATIC_IMAGE}/app/ArrivalConfirmation/producerCancel.png`}
                    alt="" 
                />
            </css.confirmationBoxFlexEnd>

            <css.buttonRow>
                <Btn href={TICK_DOMAIN} onClick={undefined}>{t('finish')}</Btn>
            </css.buttonRow>
        </Card>
    );
};

export default Canceled;